<template>
  <div class="flex items-center sm:block mt-8">
    <label class="mr-4 inline-block font-medium whitespace-no-wrap sm:mb-2">
      Exclusive deals:
    </label>
    <ul class="gap-6 sm:gap-2 flex-1 flex flex-wrap">
      <li
        v-for="category in validCategories"
        :key="category.id"
        :class="{ 'is-selected': categories.includes(category.category) }"
        class="border rounded-full py-1 px-4 cursor-pointer whitespace-no-wrap"
        @click="$emit('set-categories', category.category)"
      >
        {{ category.display_name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["categories", "type"],
  data() {
    return {
      offerCategories: [],
    };
  },
  computed: {
    validCategories() {
      if (this.type === "liveaboard") {
        return this.offerCategories.filter(
          (category) => category.is_liveaboard
        );
      } else if (this.type === "resort") {
        return this.offerCategories.filter((category) => category.is_resort);
      }

      return this.offerCategories;
    },
  },
  mounted() {
    $.ajax({
      method: "GET",
      url: window.ZUBLU_VARIABLES.ODYSSEY_API + "/api/v1/offer_categories",
      headers: { "Content-Type": "application/json" },
    }).then((response) => {
      this.offerCategories = response;
    });
  },
};
</script>

<style scoped>
li {
  margin-bottom: 0px !important;
}

.is-selected {
  background-color: var(--cyan-light-4);
}
</style>
